export default "__VITE_ASSET__e7bc6136__"